import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AffiliateLinkActivityDto, AffiliateLinkReportRequestDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { AffiliateLinkSummaryDto, CurrencyDetailDto } from 'src/app/core/dtos/affiliate-data';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-affiliate-report',
  templateUrl: './affiliate-report.component.html',
  styleUrls: ['./affiliate-report.component.scss']
})
export class AffiliateReportComponent implements OnInit {
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth();
  currentDate = new Date();
  userForm: FormGroup;
  request: AffiliateLinkReportRequestDto;
  summaryData: AffiliateLinkSummaryDto[] = [];
  purchaseActivitesList: AffiliateLinkActivityDto[] = [];

  get f() { return this.userForm.controls; }

  constructor(
    private accountService: AccountService,
    private formBuilder: FormBuilder,
    private toastService: HotToastService,
  ) { }

  ngOnInit(): void {
    this.setCurrentPayPeriod();
    this.userForm = this.formBuilder.group({
       dateFrom: [this.formatDateString(this.request.dateFrom), Validators.required],
      dateTo: [this.formatDateString(this.request.dateTo), Validators.required]
    });
    this.getReport(this.request);
  }

  updateRequest() {
    this.request = {
      dateFrom: new Date(this.userForm.controls.dateFrom.value),
      dateTo: new Date(this.userForm.controls.dateTo.value),
    };
  }

  formatDateString(date){
    let pubdate = new Date(date).toISOString().split('T')[0];
    return pubdate;
  }

  getCurrentPayPeriod() {
    this.setCurrentPayPeriod();
    this.userForm.setValue({
      dateFrom: [this.formatDateString(this.request.dateFrom)],
      dateTo: [this.formatDateString(this.request.dateTo)]
    });
    this.getReport(this.request);
  }

  getReport(request: AffiliateLinkReportRequestDto) {
    this.summaryData = [];
    this.accountService
      .getAffiliateReport(request).subscribe(
        result => {
          result.content.forEach(affiliateLink => {
            affiliateLink.purchaseActivities.forEach(purchaseActivity => {
              this.purchaseActivitesList.push(purchaseActivity);
            });
          });
          //get all purchases activities of current year
          const purchaseActivities = this.purchaseActivitesList.filter((a) => (new Date(a.dateCreatedUtc)).getFullYear() === (new Date()).getFullYear());
          let totalAmount = 0;
          purchaseActivities.forEach(purchase => {
            totalAmount += purchase.purchaseAmount;
          });
          result.content.forEach((affiliateLink => {
            const listCurrencyDetail: CurrencyDetailDto[] = [];
            let currency: string;
            affiliateLink.currencyIds.forEach(currencyId => {
              switch (currencyId) {
                case 1: currency = 'CAD'; break;
                case 2: currency = 'USD'; break;
                case 3: currency = 'CNY'; break;
                case 4: currency = 'INR'; break;
                default: currency = 'NA';
              }
              const currencyDetail: CurrencyDetailDto = {
                currency,
                id: currencyId,
                purchaseAmount: 0.0,
                payout: 0.0,
              };
              for (const item of affiliateLink.purchaseActivities) {
                if (item.currencyId === currencyId) {
                  currencyDetail.purchaseAmount = currencyDetail.purchaseAmount + item.purchaseAmount;
                  currencyDetail.payout = currencyDetail.payout + item.commissionPayout;
                }
              }
              listCurrencyDetail.push(currencyDetail);
            });
            const affiliateSummary: AffiliateLinkSummaryDto = {
              accounts: affiliateLink.createAccountActivities.length,
              clicks: affiliateLink.clickActivities.length,
              currencyDetail: listCurrencyDetail,
              deliveryMethod: affiliateLink.deliveryMethod,
              deliveryMethodId: affiliateLink.deliveryMethodId,
              description: affiliateLink.description,
              id: affiliateLink.id,
              linkName: affiliateLink.linkName,
              payout: affiliateLink.payout,
              productId: affiliateLink.productId,
              purchases: affiliateLink.purchaseActivities.length,
              purchasesAmount: totalAmount,
              purchasesNumberWithoutPayment: affiliateLink.purchaseNumberWithoutPayout,
            };
            this.summaryData.push(affiliateSummary);
          }
          ));
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
  }

  setCurrentPayPeriod() {
    let firstDay = new Date(this.currentYear, 9, 1);
    let lastDay = new Date(this.currentYear + 1, 0, 0);
    switch (this.getQuarter(null)) {
      case 1:
        firstDay = new Date(this.currentYear, 0, 1);
        lastDay = new Date(this.currentYear, 3, 0);
        break;
      case 2:
        firstDay = new Date(this.currentYear, 3, 1);
        lastDay = new Date(this.currentYear, 6, 0);
        break;
      case 3:
        firstDay = new Date(this.currentYear, 6, 1);
        lastDay = new Date(this.currentYear, 9, 0);
        break;
      case 0:
      default: break;
    }
    this.request = {
      dateFrom: new Date(firstDay.getFullYear() + "/" + (firstDay.getMonth() + 1) + "/" + firstDay.getDate()),
      dateTo: new Date(lastDay.getFullYear() + "/" + (lastDay.getMonth() + 1) + "/" + lastDay.getDate())
    };
  }

  // For the Paragon fiscal year
  // Oct-Dec = 0
  // Jan-Mar = 1
  // Apr-Jun = 2
  // Jul-Sep = 3
  getQuarter(date) {
    date = date || new Date(); // If no date supplied, use today
    const quarter = [1, 2, 3, 0];
    return quarter[Math.floor(date.getMonth() / 3)];
  }

}
